import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'hunter_bar';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyBifkZtJiF4WzB0buDoVWTdUE9rF4RxXz0',
		authDomain: 'olearys-f5ef1.firebaseapp.com',
		projectId: 'olearys-f5ef1',
		storageBucket: 'olearys-f5ef1.firebasestorage.app',
		messagingSenderId: '327368733552',
		appId: '1:327368733552:web:7247f69cd784fad48395b5',
		measurementId: 'G-FBQG7ZYP1J',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
